const searchInputs = document.querySelectorAll(".search-input");
const searchResults = document.querySelectorAll(".search-results");

searchInputs.forEach((searchInput, index) => {
  const resultsContainer = searchResults[index];

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();
    if (query.length > 2) { // Só realiza a busca se houver 3 ou mais caracteres
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
        .then(response => response.json())
        .then(data => {
          const products = data.resources.results.products;

          // Limpa os resultados anteriores
          resultsContainer.innerHTML = "";

          const searchTermElement = document.createElement("div");
          searchTermElement.classList.add("search-term");
          searchTermElement.innerHTML = `Busca por "<strong>${query}</strong>"`;
          resultsContainer.appendChild(searchTermElement);

          resultsContainer.style.display = products.length > 0 ? "block" : "none";

          // Adiciona os produtos retornados à lista de resultados
          products.forEach(product => {
            const resultItem = document.createElement("a");
            resultItem.href = product.url;
            resultItem.title = product.title;
            resultItem.classList.add("product-search");
            resultItem.innerHTML = `
              <img class="product-search-image" src="${product.image}" alt="${product.title}">
              <div class="product-search-info">
                <span class="product-search-name">${product.title}</span>
              </div>
            `;
            resultsContainer.appendChild(resultItem);
          });
        })
        .catch(error => {
          console.error("Erro ao buscar produtos:", error);
        });
    } else {
      resultsContainer.style.display = "none"; // Esconde os resultados se a busca for apagada
    }
  });

  // Esconde os resultados quando o campo de busca perde o foco
  document.addEventListener("click", function (event) {
    if (!resultsContainer.contains(event.target) && event.target !== searchInput) {
      resultsContainer.style.display = "none";
    }
  });
});


// Seleciona o header
const header = document.querySelector('header');
// Função para verificar o scroll
function handleScroll() {
  if (window.scrollY > 100) { // Se a rolagem for maior que 100px
    header.classList.add('fixed'); // Adiciona a classe "fixed"
  } else {
    header.classList.remove('fixed'); // Remove a classe "fixed"
  }
}

// Escuta o evento de rolagem
window.addEventListener('scroll', handleScroll);

//Menu Mobile
$(document).delegate(
  ".header .header-content-mobile .left .hamburguer",
  "click",
  function(){
    $('.menu-mobile').addClass('open');
  }
);

$(document).delegate(
  ".menu-mobile .menu-mobile-container .close-menu, .menu-mobile .bg-menu-mobile",
  "click",
  function(){
     $('.menu-mobile').removeClass('open');
  }
);

$(document).delegate(
  ".header .header-content-mobile .left .open-search-mobile",
  "click",
  function(){
    $('.header .header-content-mobile .search-container').toggleClass('open');
  }
);

$(document).delegate(
  ".menu-mobile .menu-mobile-container .menu-categories .menu-item.has-children .first-level-menu, .menu-mobile .menu-mobile-container .account .account-line",
  "click",
  function(){
    $(this).parent().toggleClass('active');
  }
);

//open minicart
$(document).delegate(
  ".header  .header-controls .cart",
  "click",
  function (e){
    e.preventDefault();
    const event = new Event('product:added');
    document.dispatchEvent(event);
  }
);

